import { Component, Inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SearchBoxCommonComponent } from 'avn/modules/shared/components/search-box/search-box-common/search-box-common';
import moment from 'moment';

interface ISearchBoxPopData {
  service?: string;
  location?: string;
  date?: string;
  params?: {
    claim_number?: string;
  };
}

@Component({
  selector: 'app-search-box-pop',
  templateUrl: './search-box-pop.html',
  styleUrls: ['./search-box-pop.scss'],
  imports: [SearchBoxCommonComponent]
})
export class SearchBoxPopComponent implements OnInit {
  public readonly searchSlug = signal('');
  public readonly claimNumber = signal('');
  public readonly selectedDate = signal(moment());
  public readonly locationText = signal('');

  public constructor(
    private readonly dialogRef: MatDialogRef<SearchBoxPopComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: ISearchBoxPopData
  ) {}

  public ngOnInit(): void {
    if (this.data) {
      this.searchSlug.set(this.data['service'] ?? '');
      this.claimNumber.set(this.data['params']?.['claim_number'] ?? '');
      this.selectedDate.set(moment(this.data['date']));
      this.locationText.set(this.data['location'] ?? '');
    }
  }

  public closeModal(): void {
    this.dialogRef.close();
  }
}
